module.exports = "<router-outlet></router-outlet>\n\n\n"